<script setup>
import { computed, onMounted, ref } from 'vue'
import CanvasPreviewImageWithTimelapse from '@/components/artifacts/CanvasPreviewImageWithTimelapse.vue'
import { useInstanceStore } from '@/store/backendInstances'
import { useArtifactStore } from '@/store/artifacts'
import { useDisplay } from 'vuetify/lib/framework.mjs'

const instanceStore = useInstanceStore()
const artifactStore = useArtifactStore()
const { mobile } = useDisplay()

const isLoading = ref(false)
const latestCanvasTimelapseArtifactId = ref(undefined)
const latestCanvasTimelapse = computed(() => {
  if (!latestCanvasTimelapseArtifactId.value) return undefined
  return artifactStore.getArtifact(latestCanvasTimelapseArtifactId.value)
})
const canvasTimelapseRouterLink = computed(() => {
  if (latestCanvasTimelapseArtifactId.value) {
    return {
      name: 'Artifact',
      params: {
        globalUniqueIdentifier: instanceStore.selectedInstanceId,
        artifactId: latestCanvasTimelapseArtifactId.value,
      },
    }
  }

  return {
    name: 'Artifacts',
    params: {
      globalUniqueIdentifier: instanceStore.selectedInstanceId,
    },
    query: {
      filters: encodeURIComponent(
        JSON.stringify([
          { key: 'type', operator: '==', value: 'canvasTimelapse' },
          { key: 'status', operator: 'in', value: ['done', 'archived'] },
        ])
      ),
      order: encodeURIComponent(JSON.stringify({ timestamp: 'desc' })),
    },
  }
})

onMounted(async () => {
  isLoading.value = true
  latestCanvasTimelapseArtifactId.value = await artifactStore.getLatestCanvasTimelapse(mobile.value, instanceStore.selectedInstanceId)
  isLoading.value = false
})
</script>

<template>
  <v-hover v-slot="{ isHovering, props: hoverPropsTimelapse }">
    <router-link
      class="link"
      :to="canvasTimelapseRouterLink"
    >
      <v-card-title
        v-bind="hoverPropsTimelapse"
        class="d-inline-flex align-center ga-2 cursor-pointer"
        style="max-width: 100%"
      >
        <v-icon
          icon="mdi-timelapse"
          size="small"
        />
        <span
          class="text-truncate"
          :class="{ 'text-decoration-underline': isHovering }"
        >
          {{ $t('dashboards.titles.latest_canvas_timelapse') }}
        </span>
        <v-icon
          class="redirect-arrow"
          :class="{ 'redirect-arrow-hovered': isHovering }"
          icon="mdi-arrow-right-thin"
          size="small"
        />
      </v-card-title>
    </router-link>
  </v-hover>

  <CanvasPreviewImageWithTimelapse
    v-if="latestCanvasTimelapse"
    :canvas-timelapse="latestCanvasTimelapse"
  />
  <v-skeleton-loader
    v-else
    width="100%"
    class="rounded-lg"
    type="card"
  />
</template>
